var _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetectionMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #c7ad2e;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.3,
    y: 12,
    width: 61,
    height: 61
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.3,
    y: 25,
    width: 34,
    height: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.3,48.5c3.6,0,6.5-2.9,6.5-6.5s-2.9-6.5-6.5-6.5-6.5,2.9-6.5,6.5,2.9,6.5,6.5,6.5ZM42.3,50.5c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5,8.5,3.8,8.5,8.5-3.8,8.5-8.5,8.5ZM57.3,57v-6c0-.6.4-1,1-1s1,.4,1,1v7c0,.6-.4,1-1,1h-7c-.6,0-1-.4-1-1s.4-1,1-1h6ZM27.3,57h6c.6,0,1,.4,1,1s-.4,1-1,1h-7c-.6,0-1-.4-1-1v-7c0-.6.4-1,1-1s1,.4,1,1v6ZM57.3,27h-6c-.6,0-1-.4-1-1s.4-1,1-1h7c.6,0,1,.4,1,1v7c0,.6-.4,1-1,1s-1-.4-1-1v-6ZM27.3,27v6c0,.6-.4,1-1,1s-1-.4-1-1v-7c0-.6.4-1,1-1h7c.6,0,1,.4,1,1s-.4,1-1,1h-6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.5,
    y: 11,
    width: 63,
    height: 62
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.3,
    y: 11,
    width: 63,
    height: 63
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 63,
    height: 62,
    transform: "translate(10.5 11)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/CAYAAABQHc7KAAAACXBIWXMAAAsSAAALEgHS3X78AAADu0lEQVRogeVb247rIAyE1fn/X86+NBEhHs+MoWeldqSqKQHfsI0hTWtfju50Po7D6g+Z9n78Bf2wb3Zzl0B/jcwgoYKfovgIZISHoobySj/ZFf8Hn8gIN+KC8iue4RqjyivlMxvhYlJUHo3JhGCGQDRdXjjuByP8I8JEjJWZGfvMgnTSvotXD3jgwcADMuWZcDPz1RDI+GW84uT38oLemqS8o3gmnGKEd/B6Jr+XAZQQuI0jvyNhRpdXQmOVF7u+ARkgmgXHI0ZlI0Ogca4RyorfCAYhMCvNDILA3F8xhsMn4gdl6L0f1RBQhJu9IMr+apJV+Yz0+3APekFkAKSk4hWRUOh6FjaipYaavfydcD1gFoYVLUz5quLjvSP4lrGyCjhFClO+Sv/sNyuPDPIwUMUDKiWxojyi5RRANmYDVDYgijIo8TlLIpMhW/rsOmAFSIARLPmpdFXIqwBzT9aHJcdsxiM6UXtWT8zXFDs8QDHaiUqIVRAVQSFcA2TLGoKzX8j6MCj9Hn1+hM60pATtvcUZfWzvwWcGC6ey+7cWewCb2cgLlLxQaa/MfjZxD7AQiKosNwRGqP1ZQcNmnyXKCygEmOWZMCfQLhJ9onFMrkxx6kFZDpiJrMScurV16gJnxqGcigEUBgpm5Sqbn5mv6olPYV5HYsoqELVlrsYEQIao1ghLk8M8QMkFS8uQCBbb2eynMqkhQAltHJPRco29JQl+NBwD7N4qV2hVD2QgmAGUZatyiuOCHZJkiTSVKTNARiwTyF3GrOUrkYm1hVBDYPXEpjWseHRPlQVVmlyY17MQxQAz4YrLq7O8wxDq/dYaNkClZI3GoEoNfaJxTK5MUTpBbDe4Y/ZHuHGOPCfaJZYORiMP2DX7J6IZrrRXZVpeBZzZnw8zmHJRWMxg4bDkle9+MtSal/hWgE6M0z47ToUdq7vnB1Wgk6QHKk+GlPPCyqyzs8CMLkuAEO94MuTEMcvaCg0F0CiVJ0MzsjGqMca2nrRlMrg8W2s1D4gUdl1edWWVfhnvfjLknNhmRY3CQzkffBiymgOiKgwxUoyAYpQZIqonLGRPhtRvxNjZ7c1KZmVuxgfRh6iGQGW5UxWf4fBRwuBBPPuf4HjN9uGRQJEAmUDqyQ/jQw3B/iobJbvI5Vdck+3W2G9Ei3ndDSurgMTAEAjlgR284NiLwVf/Xb41aABXEEU41L773BHydt8YyTK1UwKze6wCdHlJHncj+tUvTV2jv/m1uYvaN784OeJTDGG/OovwiS9P/wKYv7ikwRoAZgAAAABJRU5ErkJggg=="
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.5,
    y: 11,
    width: 63,
    height: 62
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.3,
    y: 24,
    width: 36,
    height: 36
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectionMedium);
export default __webpack_public_path__ + "static/media/detection-medium.1edcba0f2a48e504abce26a210104234.svg";
export { ForwardRef as ReactComponent };